// src/services/pricingService.js
import api from './api';

export const getPricingRules = () => {
  return api.get('/superadmin/pricing-rules');
};

export const getPricingRule = (action) => {
  return api.get(`/superadmin/pricing-rules/${action}`);
};

export const upsertPricingRule = (action, data) => {
  return api.put(`/superadmin/pricing-rules/${action}`, data);
};

export const deletePricingRule = (action) => {
  return api.delete(`/superadmin/pricing-rules/${action}`);
};

export default {
  getPricingRules,
  getPricingRule,
  upsertPricingRule,
  deletePricingRule,
};
